import request from '@/utils/http';

// 发送解密日志: 接口文档(https://cf.annto.com/pages/viewpage.action?pageId=101026430)
export const sendRevealLogApi = data => {
    return request({
        url: `/api-antms/common/encrypted/log/add`,
        method: 'post',
        data
    });
};
